
import 'reflect-metadata';
import { getPropNames } from '../reflection';
import { IMetricResult } from '../users/biometric';
import { BookingSourceType, BookingState,
  IUserRating, RemovedReasonType, WorkoutType, WorkoutSettingsBase } from './IUserWorkoutSessionTypes';
import { IWorkoutDates } from './IWorkoutDates';
import { IWorkoutImportContext } from './WorkoutImportConfig';

export function propNamesIUserWorkoutSessionMemberReport() { return getPropNames<IUserWorkoutSessionMemberReport>();}
export interface IUserWorkoutSessionMemberReport extends IWorkoutDates {
  uniqueReference: string;
  userProfileId: string;
  workoutType: WorkoutType;
  settings: WorkoutSettingsBase;
  recommendedSettings?: WorkoutSettingsBase;
  bookingSource: BookingSourceType;
  startTime: Date;
  timezoneOffset?: number;
  startTimeOfFirstExercise: Date;
  endTime: Date;
  originalEndTime?: Date;
  gymCheckinTime?: Date;
  removedAt: Date | false;
  createdAt: Date;
  bookingState: BookingState;
  expiresAt?: Date;
  pairedSessionReference?: string;
  pairedSessionUserProfileId?: string;
  openInviteLink: string;
  numberOfOpenSlotsAtTimeOfBooking: number;
  isPeak: boolean;
  checkedIn: boolean;
  checkinSkippedBiometric: boolean;
  anonymised: boolean;
  performanceMetrics: IMetricResult | null;
  earliestAllowedStartTime: Date;
  currentStage: number;
  gymName: string;
  workoutSelectionId: string;
  userRating: IUserRating;
  isInstant: boolean;
  isDemo: boolean;
  homeWorkoutStartedAt?: Date;
  isStreamingWorkout?: boolean;
  memberMainGym?: string;
  removedReason?: RemovedReasonType;
  additionalSecondsBeforeFirstExercise?: number;
  importOrigin?: IWorkoutImportContext;
}
